module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "page content"
  }, [(_vm.page) ? _c('div', {
    class: !_vm.loading ? '' : 'loading'
  }, [_c('hero', {
    attrs: {
      "page": _vm.page,
      "colorScheme": 'green'
    }
  }), _vm._v(" "), _c('keep-in-touch'), _vm._v(" "), _c('shop-module')], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-011141f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Participate.vue
// module id = 753
// module chunks = 1